import { createFileRoute } from '@tanstack/react-router';
import { ProjectsListPage } from '@/pages/projects-list/projects-list-page';

export const Route = createFileRoute('/projects')({ component: ProjectsListPage });
